import { TOGGLE_FEEDBACKFORM_MODAL } from '../actions/feedbackFormModal';

const initialState = {
  isOpen: false,
};

export default (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case TOGGLE_FEEDBACKFORM_MODAL:
      return {
        ...state,
        isOpen: !state.isOpen,
      };
    /* istanbul ignore next -- @preserve */
    default:
      return state;
  }
};
